import { PortalArtigoModel } from '../../../models/PortalArtigoModel'
import { getPortalPreviewTargetOrigin, getPortalPreviewUrl } from './preview-url'

export const PORTAL_PREVIEW_ARTICLE_MESSAGE_TYPE = 'NEW_DRIVER_PORTAL_PREVIEW_ARTICLE'
export const PORTAL_PREVIEW_READY_MESSAGE_TYPE = 'NEW_DRIVER_PORTAL_PREVIEW_READY'

const PORTAL_PREVIEW_WINDOW_NAME = 'newdriver-portal-preview'

export function openPortalArticlePreviewWindow() {
  const previewWindow = window.open(getPortalPreviewUrl(), PORTAL_PREVIEW_WINDOW_NAME)
  previewWindow?.focus()
  return previewWindow
}

export function postPortalArticlePreviewPayload(
  previewWindow: Window | null,
  artigo: PortalArtigoModel
) {
  if (!previewWindow || previewWindow.closed) return false

  previewWindow.postMessage(
    {
      type: PORTAL_PREVIEW_ARTICLE_MESSAGE_TYPE,
      payload: artigo,
    },
    getPortalPreviewTargetOrigin()
  )

  return true
}

export function isPortalPreviewReadyMessage(event: MessageEvent) {
  return (
    event.origin === getPortalPreviewTargetOrigin() &&
    event.data?.type === PORTAL_PREVIEW_READY_MESSAGE_TYPE
  )
}
